import { render, staticRenderFns } from "./DepositRule.vue?vue&type=template&id=3fe82642"
import script from "./DepositRule.vue?vue&type=script&lang=ts"
export * from "./DepositRule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports